export default __webpack_public_path__ + "svTransLogoBg.7a20d2401a28b6537f4bf297bfb67e45.png";